export interface IUserPermissions {
  accounts_charge_all: boolean;
  accounts_import: boolean;
  accounts_post_adjustment: boolean;
  admin_accounts_disable: boolean;
  admin_accounts_edit: boolean;
  admin_permissions_edit: boolean;
  facility_admin_enter: boolean;
  admin_edit_shift_history: boolean;
  admin_view_shift_wages: boolean;
  admin_view_shift_summary: boolean;

  bookings_edit_note: boolean;

  cash_outs_create: boolean;
  cash_outs_edit: boolean;
  cash_outs_view_summary: boolean;
  courses_create: boolean;
  created_at: string;
  customers_edit_note: boolean;
  customers_ban_account: boolean;
  credit_books_make_adjustments: boolean;
  deleted_at: string;
  discounts_create: boolean;
  divisions_create: boolean;

  gift_cards_import: boolean;
  gift_cards_enable: boolean;
  gift_cards_view: boolean;

  id: number;

  departments_create: boolean;
  departments_edit: boolean;

  enable_service_fees: boolean;

  memberships_apply_manual: boolean;
  merge_customers: boolean;

  orders_access: boolean;
  orders_apply_discount: boolean;
  orders_backdate: boolean;
  orders_edit_line_item_price: boolean;
  orders_edit_register: boolean;
  orders_edit_user: boolean;
  orders_refund: boolean;
  orders_refund_tip: boolean;
  orders_edit_tip_allocations: boolean;
  orders_refund_service_fee: boolean;
  orders_remove_line_item: boolean;
  orders_remove_line_item_after_send: boolean;
  orders_void: boolean;
  orders_void_line_item: boolean;
  orders_view_all: boolean;

  payment_options_create: boolean;
  payment_settings_edit: boolean;

  products_access: boolean;
  products_archive: boolean;
  products_view_all: boolean;
  products_create: boolean;
  products_edit: boolean;
  products_edit_cost: boolean;
  products_edit_price: boolean;

  reports_access: boolean;
  tee_sheet_credit_card_override: boolean;
  tee_sheet_charge_no_show: boolean;
  tee_sheet_starter: boolean;
  tee_sheet_access: boolean;
  tee_sheet_access_code: boolean;
  edit_daily_status: boolean;
  table_service_table_override: boolean;

  kiosk_view: boolean;

  reservations_credit_card_override: boolean;
  reservations_module_new: boolean;
  reservations_module_edit: boolean;
  reservations_location_new: boolean;
  reservations_location_edit: boolean;

  user_id: number;
  updated_at: string;

  user_edit_customer_type: boolean;
  tax_lines_archive: boolean;

  bank_accounts_create: boolean;
  booking_category_create: boolean;

  tee_on_payments_view_persons: boolean;

  tickets_archive: boolean;
  tickets_unredeem: boolean;

  facility_details_edit: boolean;
  tabs_close: boolean;
  booking_restrictions_edit: boolean;

  loyalty_program_points_adjustment: boolean;

  customers_access: boolean;
  settings_access: boolean;

  payment_option_deposit: boolean;

  // Financial Reports
  reports_facility_accounts_receivable: boolean;
  reports_facility_aged_accounts_receivable: boolean;
  reports_facility_cash_reconciliation: boolean;
  reports_facility_daily_sales: boolean;
  reports_facility_deposits: boolean;
  reports_facility_detailed_sales_and_inventory_by_department: boolean;
  reports_facility_detailed_sales_by_department: boolean;
  reports_facility_events_not_invoiced: boolean;
  reports_facility_form_responses: boolean;
  reports_facility_credit_book_transactions: boolean;
  reports_facility_gift_card_activity: boolean;
  reports_facility_gift_cards: boolean;
  reports_facility_gl_golfnorth: boolean;
  reports_facility_golfnorth_daily_sales: boolean;
  reports_facility_hospitality_events_not_invoiced: boolean;
  reports_facility_inventory_adjustments: boolean;
  reports_facility_inventory_count_by_department: boolean;
  reports_facility_inventory_listing_by_department: boolean;
  reports_facility_invoices: boolean;
  reports_facility_item_sales_history: boolean;
  reports_facility_membership_sales: boolean;
  reports_facility_customers_created: boolean;
  reports_facility_order_exceptions: boolean;
  reports_facility_orders: boolean;
  reports_facility_orders_by_register: boolean;
  reports_facility_payouts: boolean;
  reports_facility_processing_fee_transactions: boolean;
  reports_facility_processing_fee_monthly_summary: boolean;
  reports_facility_player_spend: boolean;
  reports_facility_prize_accounts: boolean;
  reports_facility_product_sales: boolean;
  reports_facility_products: boolean;
  reports_facility_rain_checks: boolean;
  reports_facility_rounds_by_customer_type: boolean;
  reports_facility_sales_by_accounting_reference: boolean;
  reports_facility_sales_by_department: boolean;
  reports_facility_sales_by_register: boolean;
  reports_facility_sales_by_staff_member: boolean;
  reports_facility_scheduled_payments: boolean;
  reports_facility_server_summaries: boolean;
  reports_facility_ticket_overview: boolean;
  reports_facility_tickets: boolean;
  reports_facility_tickets_expired: boolean;
  reports_facility_tickets_redeemed: boolean;
  reports_facility_tips_by_order: boolean;
  reports_facility_tournaments: boolean;
  reports_facility_transactions: boolean;
  reports_facility_transactions_by_register: boolean;
  reports_facility_user_payment_methods: boolean;
  reports_facility_po_outstanding_items: boolean;

  // Tee Sheet Reports
  reports_facility_booking_exceptions: boolean;
  reports_facility_email_activity: boolean;
  reports_facility_tee_sheet_no_show: boolean;
  reports_facility_power_carts: boolean;
  reports_facility_rounds_by_booking_category: boolean;
  reports_facility_rounds_played_by_customer: boolean;
  reports_facility_tee_sheet_open_close: boolean;
  reports_facility_tee_sheet_overview: boolean;
  reports_facility_tee_sheet_utilization: boolean;
  reports_facility_revpar: boolean;
  reports_facility_tee_time_promotions: boolean;
  reports_facility_waitlist: boolean;

  // Event Reports
  reports_facility_hospitality_events: boolean;
  reports_facility_leagues: boolean;

  // Status Reports
  reports_facility_inventory: boolean;

  // Other
  reports_facility_other_report: boolean;

  reports_facility_golfnorth_invoice_daily_sales: boolean;

  reports_client_scheduled_payments: boolean;
  reports_client_account_adjustments: boolean;
  reports_client_detailed_sales_by_department: boolean;
  reports_client_aged_accounts_receivable: boolean;
  reports_client_membership_sales: boolean;
  reports_client_order_exceptions: boolean;
  reports_client_tee_sheet_utilization: boolean;
  reports_client_accounts: boolean;
  reports_client_tournaments: boolean;
  reports_client_tournaments_not_invoiced: boolean;
  reports_client_deposits: boolean;
  reports_client_invoices: boolean;
  reports_client_prize_accounts: boolean;
  reports_client_inventory_listing_by_department: boolean;
  reports_client_detailed_sales_and_inventory_by_department: boolean;
  reports_client_leagues: boolean;
  reports_client_hospitality_events: boolean;
  reports_client_form_responses: boolean;
}

export interface IUser {
  birth_date: string | null;
  client_id: number;
  customer_code: string;
  email: string;
  facility_id: number;
  first_name: string;
  full_name: string;
  id: number;
  last_name: string;
  member_number: null | number;
  password_reset_code: null | string;
  permissions: IUserPermissions;
  phone: null | string;
  primary_locale: string;
  primary_locale_country: string;
  state: null | string;
  stripe_id: null | number;
  user_type: UserType;
  verification_code: null | string;
  profile_image_source: string;
  profile_image_source_path: string;
  initials?: string;
  /** Present when Master Admin or Client Admin has entered Facility Admin as support */
  support_session?: boolean;
  support_session_origin?: "master_admin" | "client_admin";

  // id: number;
  // client_id: number;
  // email: string;
  // facility_id: number;
  // first_name: string;
  // full_name: string;
  // last_name: string;
  // user_type: UserType;
  // primary_locale: string;
  // primary_locale_country: string;
  // permission: {
  //   level: AdminPermission;
  //   name: string;
  //   type: "permission";
  // };
}

export type IUserActive = Omit<IUser, "verification_code">;

export enum UserType {
  STANDARD_CUSTOMER = 1,
  CLIENT_ADMIN = 2,
  FACILITY_ADMIN = 3,
  MASTER_ADMIN = 4,
}

export enum AdminPermission {
  FACILITY_ADMIN = "facility_admin",
  CLIENT_ADMIN = "client_admin",
  MASTER_ADMIN = "master_admin",
}
